export function setReservas(state, reservas) {
    state.reservas = reservas;
    state.reservas.forEach(element => {
        element.hide = false
    });
}

export function setReservaSelec(state, reserva) {
    state.reservaSelec = reserva;
}

export function setEstaSolapadaConConfirmada(state, estaSolapadaConConfirmada) {
    state.estaSolapadaConConfirmada = estaSolapadaConConfirmada;
}


export function setTotalReservas(state, total) {
    state.totalReservas = total;
}



export function setReservasCalendario(state, data) {
    state.reservasCalendario = data.reservas;
    state.tallerCalendario = data.taller;

    for (let index = 0; index < state.reservasCalendario.length; index++) {
        const res = state.reservasCalendario[index];
        state.reservasCalendario[index].color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
    }

}

export function setDisponibilidadAnual(state, dispo) {
    state.disponibilidadAnual = dispo.disponibilidad;
}

export function setDialogWidth(state, width) {
    state.dialogWidth = width
}

export function setRutaSelec(state, rutaSelec) {
    state.rutaSelec = rutaSelec;
    if (state.rutaSelec != null && state.fechaSelec != null) {
        state.dialogWidth = '1400px';
    } else {
        state.dialogWidth = '600px';
    }
}

export function setFechaSelec(state, fechaSelec) {
    state.fechaSelec = fechaSelec;
    if (state.rutaSelec != null && state.fechaSelec != null) {
        state.dialogWidth = '1400px';
    } else {
        state.dialogWidth = '600px';
    }
}

export function setPagado(state, pagado) {
    state.pagado = pagado;
}

export function setPendiente(state, pendiente) {
    state.pendiente = pendiente;
}

export function setFrom(state, from) {
    state.from = from;
}

export function setUntil(state, until) {
    state.until = until;
}



export function reiniciarTarifas(state) {
    if (state.rutaSelec != null) {
        state.rutaSelec.tarifas.forEach(element => {
            element.pax = 0;
        });
    }

}

export function actUpdateListReservas(state, reserva) {
    if (reserva !== null) {
        const index = state.reservas.findIndex(r => r.id === reserva.id)
        if (index != -1) {
            state.reservas[index].fecha_inicio = reserva.fecha_inicio;
            state.reservas[index].fecha_llegada = reserva.fecha_llegada;
            state.reservas[index].camino = reserva.camino;
            state.reservas[index].cliente = reserva.cliente;
            state.reservas[index].alojamientos = reserva.alojamientos;
            state.reservas[index].cant_habitaciones = reserva.cant_habitaciones;
            state.reservas[index].cant_peregrinos = reserva.cant_peregrinos;
            state.reservas[index].comentarios = reserva.comentarios;
            state.reservas[index].estado = reserva.estado;
            state.reservas[index].origen = reserva.origen;
            state.reservas[index].created_at = reserva.created_at;
            state.reservas[index].codigo = reserva.codigo;
            state.reservas[index].importe_presupuestado = reserva.importe_presupuestado;
            state.reservas[index].descripcion_importe_presupuestado = reserva.descripcion_importe_presupuestado;
            state.reservas[index].language = reserva.language;
        }
    }
    if (state.reservaSelec != null && state.reservaSelec.id === reserva.id) {
        state.reservaSelec.fecha_inicio = reserva.fecha_inicio;
        state.reservaSelec.fecha_llegada = reserva.fecha_llegada;
        state.reservaSelec.camino = reserva.camino;
        state.reservaSelec.cliente = reserva.cliente;
        state.reservaSelec.alojamientos = reserva.alojamientos;
        state.reservaSelec.cant_habitaciones = reserva.cant_habitaciones;
        state.reservaSelec.cant_peregrinos = reserva.cant_peregrinos;
        state.reservaSelec.comentarios = reserva.comentarios;
        state.reservaSelec.estado = reserva.estado;
        state.reservaSelec.origen = reserva.origen;
        state.reservaSelec.created_at = reserva.created_at;
        state.reservaSelec.codigo = reserva.codigo;
        state.reservaSelec.importe_presupuestado = reserva.importe_presupuestado;
        state.reservaSelec.descripcion_importe_presupuestado = reserva.descripcion_importe_presupuestado;
        state.reservaSelec.language = reserva.language;
    }
}



export function actDeleteListReservas(state, id) {
    if (id != null) {


        for (let index = 0; index < state.reservas.length; index++) {
            const res = state.reservas[index];
            if (res.id == id) {
                state.reservas.splice(index, 1);
            }
        }


        const index = state.reservas.findIndex(r => r.id == id)
        if (index != -1) {
            state.reservas.splice(index, 1);
        }
    }
}